export const sizes = {
  fullWidth: '112rem',
};
